import { arrToString } from "../helpers";

export abstract class ComponentBase {
  protected arrToStr = arrToString;
}
